__turbopack_context__.v({
  "darktext": "N5fNEW_darktext",
  "form": "N5fNEW_form",
  "formControls": "N5fNEW_formControls",
  "formMessage": "N5fNEW_formMessage",
  "richtext": "N5fNEW_richtext",
  "rowSwapped": "N5fNEW_rowSwapped",
  "splitview": "N5fNEW_splitview",
  "splitviewimage": "N5fNEW_splitviewimage",
  "splitviewtext": "N5fNEW_splitviewtext",
  "swapped": "N5fNEW_swapped",
});
